import { useLocalStorageTheme, useThemeSyncer } from '@components/theme-provider';
import { TooltipStyles } from '@components/tooltip';
import { DatePickerStyles } from '@styles/datepicker';

import { QueryClientProvider } from 'api/query-client';
import { RouterProvider } from 'ui/router';

export const App = () => {
  const { storedTheme } = useLocalStorageTheme('journeys');
  useThemeSyncer(storedTheme);

  return (
    <QueryClientProvider>
      <RouterProvider />
      <DatePickerStyles />
      <TooltipStyles />
    </QueryClientProvider>
  );
};
